export default __webpack_public_path__ + "static/media/te_lavirginia.fd399496.jpg";